<div class="match">
  <header *ngIf="ready">
    <h3>
      <span *ngIf="multi">Select your email</span>
      <span *ngIf="!multi">Is this your email?</span>
    </h3>
    <p class="subheader">
      Based on the information provided, it looks like you may already have an account<span *ngIf="multi">.</span>
      <span *ngIf="!multi"> with the following email address</span>
      <span *ngIf="multi"> Select your email to use the account.</span>
    </p>
  </header>

  <div role="content">
    <div *ngIf="!ready">
      <se-fe-spinner
        [seFeDataSize]="900"
        [seFeDataInverted]="false"
        [seFeDataCenter]="true">
      </se-fe-spinner>
    </div>
    <div *ngIf="ready">
      <form
        [formGroup]="form"
        (ngSubmit)="submit()"
        [action]="actionUrl"
        method="POST"
        novalidate>
        <input type="hidden" name="authenticity_token" [value]="csrfToken">
        <se-fe-form-field *ngIf="multi"
          [seFeDataConfig]="{
            label: 'Confirm your email',
            hiddenLabel: true,
            errorMessages: { required: 'Please confirm your email.' }
          }">
          <se-fe-radios
            formControlName="selectedUser"
            [seFeDataOptions]="options">
          </se-fe-radios>
        </se-fe-form-field>

        <h3 *ngIf="!multi" class="form-field">
          {{ options[0].label }}
        </h3>

        <div class="form-field">
          <se-fe-button
            seFeDataEmphasis="high"
            seFeDataType="submit"
            [seFeDataIsLoading]="submitting"
            [seFeDataFullWidth]="true">
            <span *ngIf="multi">Continue</span>
            <span *ngIf="!multi">Yes</span>
          </se-fe-button>

          <se-fe-button
            seFeDataEmphasis="medium"
            seFeDataType="button"
            [seFeDataIsLoading]="submitting"
            [seFeDataFullWidth]="true"
            (click)="noMatch()">
            <span *ngIf="multi">None of these are my email</span>
            <span *ngIf="!multi">No this is not my email</span>
          </se-fe-button>
        </div>
      </form>

      <form [action]="actionUrl" method="POST" #signInForm>
        <input type="hidden" name="user[login]" [value]="form.value.selectedUser">
        <input type="hidden" name="user[user_duplicate_lookup_id]" [value]="store.dupes.id">
        <input type="hidden" name="authenticity_token" [value]="csrfToken">
      </form>
    </div>
  </div>
</div>
